import axios from 'axios';
import {
  COLLECTION_MIS_REQUEST,
  COLLECTION_MIS_SUCCESS,
  COLLECTION_MIS_FAIL,
  COLLECTION_SUPERVISORS_REQUEST,
  COLLECTION_SUPERVISORS_SUCCESS,
  COLLECTION_SUPERVISORS_FAIL,
} from '../constants/collectionMisConstants';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const fetchCollectionMis = (month = '', year = '') => async (dispatch, getState) => {
  try {
    dispatch({ type: COLLECTION_MIS_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.get(
      `${API_URL}/collection-mis?month=${month}&year=${year}`,
      { headers: { Authorization: `Bearer ${userInfo.token}` } },
    );
    dispatch({ type: COLLECTION_MIS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: COLLECTION_MIS_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const fetchCollectionSupervisors = () => async (dispatch, getState) => {
  try {
    dispatch({ type: COLLECTION_SUPERVISORS_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.get(
      `${API_URL}/collection-mis/supervisors`,
      { headers: { Authorization: `Bearer ${userInfo.token}` } },
    );
    dispatch({ type: COLLECTION_SUPERVISORS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: COLLECTION_SUPERVISORS_FAIL, payload: error.response?.data?.message || error.message });
  }
};
